import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './PrimeiroAcesso.module.css';
import logo from '../assets/images/logo_old.png';
import styles_content from "./css/main-content.module.css";

function PrimeiroAcesso() {
  const { id } = useParams();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmNewPasswordChange = (e) => {
    setConfirmNewPassword(e.target.value);
  };

   useEffect(() => {
          if (error) {
              const timer = setTimeout(() => {
                  setError(null);
              }, 30000);
              return () => clearTimeout(timer);
          }
      }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmNewPassword) {
      setError('As novas senhas não coincidem.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${BASE_URL}/hello-sol/usuarios/alterar-senha/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          oldPassword: oldPassword,
          newPassword: newPassword,
        }),
      });

      if (response.ok) {
        setError('');
        navigate('/home');
      } else {
        const errorData = await response.json();
        let errorMessage = errorData.message.replace(/^[^\=]+\=+/, '').trim();
        errorMessage = errorMessage.replace(/[\[\]]/g, ''); // Remove colchetes
        throw new Error(errorMessage || 'Erro ao cadastrar usuário.');      }
    } catch (error) {
      console.error('Erro ao fazer a requisição:', error.message);
      setError(error.message);
    }
  };

  return (
    <div className={styles.primeiroAcessoContainer}>
      <div className={styles.primeiroAcessoContent}>
        <div className={styles.primeiroAcessoLogoContainer}>
          <a href="/">
            <img src={logo} alt="Hello Sol" />
          </a>
        </div>
        <h2>Alterar Senha de Primeiro Acesso</h2>
        {error && <p className={styles.errorMessage}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <div>
            <input
              type="password"
              value={oldPassword}
              onChange={handleOldPasswordChange}
              placeholder="Senha Antiga"
              maxLength="30"
            />
          </div>
          <div>
            <input
              type="password"
              value={newPassword}
              onChange={handleNewPasswordChange}
              placeholder="Nova Senha"
              maxLength="30"
            />
          </div>
          <div>
            <input
              type="password"
              value={confirmNewPassword}
              onChange={handleConfirmNewPasswordChange}
              placeholder="Confirmar Nova Senha"
              maxLength="30"
            />
          </div>
          <button type="submit" className={styles_content.buttonGroup}>
            Alterar Senha
          </button>
        </form>
      </div>
    </div>
  );
}

export default PrimeiroAcesso;
